import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=c72cbc8c&scoped=true"
import script from "./ArrowLink.vue?vue&type=script&lang=ts"
export * from "./ArrowLink.vue?vue&type=script&lang=ts"
import style0 from "./ArrowLink.vue?vue&type=style&index=0&id=c72cbc8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_bc25730245fecb6fd7811a0f2bdc44a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72cbc8c",
  null
  
)

export default component.exports